import { Reveal } from "../landing/Reveal";

const TRIPS = [
  { emoji: "🏖️", name: "Goa", price: "₹2,999", tag: "Student Package", grad: "from-[#F97316] to-[#22C55E]" },
  { emoji: "🌴", name: "Bali", price: "₹24,999", tag: "Group Deal", grad: "from-[#06B6D4] to-[#4ADE80]" },
  { emoji: "🏔️", name: "Manali", price: "₹3,999", tag: "Weekend", grad: "from-[#7C3AED] to-[#A78BFA]" },
  { emoji: "🛕", name: "Thailand", price: "₹29,999", tag: "Educational Tour", grad: "from-[#22C55E] to-[#F97316]" },
];

export const TravelBite = () => (
  <section id="travelbite" data-testid="travelbite-section" className="relative overflow-hidden py-20 sm:py-24">
    <div aria-hidden="true" className="absolute -right-32 top-1/3 h-[380px] w-[380px] rounded-full bg-[#06B6D4]/10 blur-[130px]" />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="font-jbmono text-xs uppercase tracking-[0.3em] text-[#06B6D4]">✈️ TravelBite</p>
        <h2 className="mt-3 max-w-xl font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
          Airbnb wanderlust, student-wallet prices.
        </h2>
      </Reveal>

      <div className="mt-12 grid grid-cols-2 gap-4 lg:grid-cols-4">
        {TRIPS.map((t, i) => (
          <Reveal key={t.name} delay={0.06 * i} className="h-full">
            <div
              data-testid={`trip-${t.name.toLowerCase()}`}
              className={`group relative flex h-64 flex-col justify-end overflow-hidden rounded-3xl border border-white/10 bg-gradient-to-b p-5 sm:h-72 ${t.grad}`}
            >
              <div aria-hidden="true" className="absolute inset-0 bg-gradient-to-t from-[#09090B]/85 via-transparent to-transparent" />
              <span className="absolute left-1/2 top-1/4 -translate-x-1/2 text-6xl drop-shadow-2xl transition-transform duration-500 group-hover:scale-125">
                {t.emoji}
              </span>
              <div className="relative">
                <span className="rounded-full bg-white/15 px-2.5 py-1 font-jbmono text-[9px] font-bold uppercase tracking-wider text-white backdrop-blur-md">
                  {t.tag}
                </span>
                <p className="mt-2 font-display text-xl font-extrabold text-white">{t.name}</p>
                <p className="font-jbmono text-xs text-[#06B6D4]">{t.price} / person</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
